export default "__VITE_ASSET__CkfsG_zU__"